import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createModel, searchModels } from '../../../../redux/DefaultModelActions';
import { dispatchLoading, dispatchError, dispatchSuccess, dispatchClearState } from '../../../../redux/utils';
import { APIPost, APIBase, APIGet } from '../../../../services/API';
import { FullEngagements } from './userengagement.selectors';

const model = 'UserEngagement';
const route = '/v1/engagement';

export const searchEngagements = (page, limit, search, view, args) => searchModels(model, route, page, limit, search, view, args);

export const toggleEngagement = (args) => dispatch => {

    const prefix = 'toggle';
    const action = `[${model.toUpperCase()}] Toggle ${model}`;


    // Update The UI
    dispatch(dispatchLoading(action, prefix));

    // Make Request
    APIPost(`${APIBase}${route}`, args)
        .then(res => res.json())
        .then(json => {
            if (json.status === 'error') {

                dispatch(dispatchError(action, prefix, json.message))
            }
            else {

                // Dispatch Success
                dispatch(dispatchSuccess(action, prefix, json.message, json.data));

                // Dispatch Clear State
                setTimeout(() => { dispatch(dispatchClearState(action, prefix)) }, 1500)

            }
        })
        .catch(e => {
            // dispatch(openToast(e.message,'error'))
            dispatch(dispatchError(action, prefix, e.message))
        })

}

export const useEngagementTotal = ({ modelId = null, engagement = null }) => {

    const [total, setTotal] = useState(null);
    const [totalLoading, setLoading] = useState(false);

    const getTotals = async () => {

        setLoading(true);

        const path = `${APIBase}/v1/engagement/total/${engagement}/${modelId}`;

        try {
            const res = await APIGet(path)
            const json = await res.json();
            setTotal(json?.data?.total);
            setLoading(false);
            return json;
        } catch (error) {
            setLoading(false);
            return error;
        }

    }

    useEffect(() => {

        getTotals();

    }, [modelId, engagement])


    return {
        total,
        totalLoading
    }
}

export const useEngagement = ({ modelId, modelType }) => {

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const store = FullEngagements();


    const key = `engagement_${modelType}_${modelId}`;

    useEffect(() => {
        const args = {}
        args.prefix = key;
        args.modelId = `["${modelId}"]`;
        args.modelType = `["${modelType}"]`;
        if (store[key]?.count > 0) return;
        dispatch(searchEngagements(0, 999, null, null, args));
    }, [modelId, modelType])

    const res = (store[key]?.count > 0) ? store[key].rows : [];

    return {
        loading,
        engagements: res
    }

    // const [item, setItem] = useState(null);
    // const [loading, setLoading] = useState(true);
    // const fullAssets = FullAssets();


    // const load = async (id) => {
    //     if (!id) return;
    //     const g = getGlobalStorage(id);

    //     if (g) {
    //         setItem(g);
    //         return;
    //     }

    //     // console.log(fullAssets, "FULL ASSETS")

    //     setLoading(true);
    //     const res = await loadAsset(id);
    //     if (res.status === 'success') {
    //         setItem(res.data);
    //         setGlobalStorage(id, res.data);
    //         setLoading(false);
    //     } else {
    //         setLoading(false);
    //     }
    // }

    // useEffect(() => {
    //     if (item && item.id === id) return;
    //     load(id); // Load the Guide
    // }, [id])

    // useEffect(() => {

    //     if (!model?.full) setItem(model);
    //     else if (model?.full?.id) setItem(model.full);
    //     else {
    //         // Shhhh
    //     }
    // }, [model]);


    // return {
    //     assetLoading: loading,
    //     asset: item,
    // }

}
